<template>
  <BaseModal v-model="model" :max-width="550">
    <div v-if="textType == 'refill'">
      <h2 class="upgrade-modal__text">{{ t('referralSystem.upsell.refilledTitle', {numberFreeProQuestions: maxWeekProUsage}) }}</h2>
      <p>{{ t('referralSystem.upsell.refilledDescription') }}</p>
    </div>
    <div v-if="textType == 'firstTime'">
      <h2 class="upgrade-modal__text">{{ t('referralSystem.upsell.firstTimeTitle', {numberFreeProQuestions: maxWeekProUsage}) }}</h2>
      <p>{{ t('referralSystem.upsell.firstTimeDescription') }}</p>
    </div>
    <div v-if="textType == 'usedAll'">
      <h2 class="upgrade-modal__text">{{ t('referralSystem.upsell.usedAllTitle') }}</h2>
      <p>{{ t('referralSystem.upsell.usedAllDescription1') }}</p>
      <br/>
      <p>{{ t('referralSystem.upsell.usedAllDescription2') }}</p>
    </div>
    <div v-if="textType == 'proUpsell'">
      <h2 class="upgrade-modal__text">{{ t('referralSystem.upsell.proTitle') }}</h2>
      <p>{{ t('referralSystem.upsell.proDescription') }}</p>
    </div>
    
    <div class="upgrade-modal__action-container">
      <button class="upgrade-modal__button btn-earn-free-pro" @click="closeModal">
       {{ t('referralSystem.upsell.btnAccept') }}
      </button>
      <button class="upgrade-modal__button btn-upgrade" @click="acceptEarnFreePro">
        {{ t('referralSystem.upsell.btnEarnFreePro') }}
      </button>
      <UpgradeButton v-if="textType != 'proUpsell'" class="upgrade-modal__button" />
    </div>
  </BaseModal>
</template>
<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BaseModal from '@/components/BaseModal.vue';
import UpgradeButton from '@/features/Header/components/UpgradeButton.vue';

// Define the emit function for the 'applyWaveAnimation' event
const emit = defineEmits(['applyWaveAnimation', 'newChat']);
const store = useStore();
const { t } = useI18n();
const router = useRouter();
const maxWeekProUsage = computed(() => store.state.maxWeekProUsage);
const textType = computed(() => store.state.upsellProModalText );
const model = computed({
  get: () => store.state.upsellProModal,
  set: (val) => { 
    store.commit('SET_STATE_PROPERTY', {
      property: 'upsellProModalText',
      value: 'firstTime',
    });

    store.commit('SET_STATE_PROPERTY', {
      property: 'upsellProModal',
      value: val,
    });
  },
});

const closeModal = () => {

  if (textType.value === 'usedAll') {
    store.dispatch('newChat');
  }
  
  store.dispatch('trackEvent', {
    event: 'UpsellReferralModalClose',
    values: {
      textType: textType.value,
    },
  });

  store.commit('SET_STATE_PROPERTY', {
    property: 'blinkProModalText',
    value: true,
  });
  model.value = false; // Close the modal
};

const acceptEarnFreePro = () => {
  store.dispatch('trackEvent', {
    event: 'UpsellReferralModalRedirReferral',
    values: {
      textType: textType.value,
    },
  });
  model.value = false; // Close the modal first
  router.push('/referrals'); // Redirect to referrals route
};
</script>
<style lang="scss" scoped>
.upgrade-modal {
  &__text {
    margin-top: 2px;
    margin-bottom: 16px;
  }
  &__action-container {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    margin-bottom: 16px;
    gap: 10px;
  }
  &__button {
    flex: 0.8; // Reduce from 1 to make buttons narrower
    min-width: 0;
    max-width: 150px; // Add max-width to limit button size
  }
}

.btn-earn-free-pro, .btn-upgrade, .upgrade-modal__button {
  padding: 6px 4px;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  font-weight: 500;
}
.upgrade-modal__button{
  height: 36px;
  font-weight: 600;
}

.btn-earn-free-pro {
  background-color: #DDDFEA;
  color: #333;
}

.btn-upgrade {
  background-color: #6F9EFC;
  color: white;
}
.upgrade-modal__button {
  font-size: 17px;
}
</style>
